import { render, staticRenderFns } from "./EditUsersProfile.html?vue&type=template&id=2656f1cd&scoped=true&"
import script from "./EditUsersProfile.js?vue&type=script&lang=js&"
export * from "./EditUsersProfile.js?vue&type=script&lang=js&"
import style0 from "./EditUsersProfile.vue?vue&type=style&index=0&id=2656f1cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656f1cd",
  null
  
)

export default component.exports